/**
 * PK 答题加解密 — 全局 hz.api.crypto 启用时由 request.js 统一处理，此处仅作兼容。
 */
import request from '@/utils/request'
import {
  isApiEncryptedMode,
  encodeApiPayloadEnc,
  decodeApiPayloadEnc,
  unwrapApiResponse
} from '@/utils/apiCrypto'

const SUBMIT_ANSWER_SIGN_KEYS = ['answer', 'questionId', 'roomCode', 'timeUsed']

export function isPkEncryptedMode() {
  if (isApiEncryptedMode()) return false
  const mode = (process.env.VUE_APP_PK_CRYPTO_MODE || 'plain').trim()
  const secret = (process.env.VUE_APP_PK_CRYPTO_SECRET || '').trim()
  return mode === 'encrypted' && secret.length > 0
}

export function wrapPkSubmitBody(data) {
  if (isApiEncryptedMode()) {
    return data
  }
  if (!isPkEncryptedMode()) {
    return data
  }
  const picked = {}
  SUBMIT_ANSWER_SIGN_KEYS.forEach((k) => {
    if (data[k] !== undefined && data[k] !== null) {
      picked[k] = data[k]
    }
  })
  return { payloadEnc: encodeApiPayloadEnc(picked) }
}

export function unwrapPkResponse(res, url) {
  if (isApiEncryptedMode() && url) {
    return unwrapApiResponse(url, res)
  }
  if (!isPkEncryptedMode()) {
    return res
  }
  if (!res || res.code !== 200 || !res.data) {
    return res
  }
  const enc = res.data.payloadEnc
  if (!enc) {
    return res
  }
  try {
    return { ...res, data: decodeApiPayloadEnc(enc) }
  } catch (e) {
    console.error('[PK_CRYPTO] 解密失败', e)
    return { ...res, code: 500, msg: '数据解密失败', data: null }
  }
}

export async function pkApiRequest(config) {
  // 全局加密由 request.js 拦截器统一处理，避免重复加解密
  if (isApiEncryptedMode()) {
    return request(config)
  }
  if (config.data != null && isPkEncryptedMode()) {
    config = { ...config, data: wrapPkSubmitBody(config.data) }
  }
  const res = await request(config)
  return unwrapPkResponse(res, config.url)
}

// 兼容旧引用
export { isApiEncryptedMode }
